import React, { useContext } from 'react';
import { MuiPaginationContext } from '@lsoft/mui';
import { Alert } from '@material-ui/lab';
import { Tr } from '@lsoft/translate';
import PropTypes from 'prop-types';

export const MuiPaginationEmptyAlert = ({ tr, children }) => {
	const { end, initialized } = useContext(MuiPaginationContext);

	if (end === 0 && initialized) {
		return (
			<Alert variant={'standard'} severity={'info'}>
				<Tr tr={tr} />
			</Alert>
		);
	} else {
		return children;
	}
};

MuiPaginationEmptyAlert.propTypes = {
	tr: PropTypes.object.isRequired,
};
